import styled from "styled-components";

export const StyledRadioGroupWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
